"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logic_1 = require("./logic");
const view_1 = require("./view");
const React = require("react");
/**Un boton */
class CustomButton extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.normal = (props) => React.createElement(this.props.View, Object.assign({}, this.props, props, { loading: false, error: false, disabled: false }));
        this.error = (props) => React.createElement(this.props.View, Object.assign({}, this.props, props, { loading: false, disabled: false, error: true }));
        this.disabled = (props) => React.createElement(this.props.View, Object.assign({}, this.props, props, { loading: false, disabled: true, error: false, onClick: undefined }));
        this.loading = (props) => React.createElement(this.props.View, Object.assign({}, this.props, props, { loading: true, disabled: true, error: false, onClick: undefined }));
    }
    render() {
        return React.createElement(logic_1.LogicButton, Object.assign({}, this.props, { normalComp: this.normal, errorComp: this.error, disabledComp: this.disabled, loadingComp: this.loading }));
    }
}
/**Un botón  */
class Button extends React.PureComponent {
    render() {
        return React.createElement(CustomButton, Object.assign({}, this.props, { View: view_1.ButtonView }));
    }
}
exports.Button = Button;
/**Un botón en forma de link */
class Link extends React.PureComponent {
    render() {
        return React.createElement(CustomButton, Object.assign({}, this.props, { View: view_1.LinkView }));
    }
}
exports.Link = Link;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/botones/button.js
// module id = 2201
// module chunks = 0